export class MoverCategoriaFinanceiraRequest {
    idsCategorias: number[] = [];
    idCategoriaFinanceiraPaiDestino?: number | null;
    public idCategoriaMigracao?: number;
}
